import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["filterContainer", "toggleBtn"];

  connect() {
    this.idPrefix = this.element.dataset.prefix || 'default';
    if (this.idPrefix === 'amenities') {
      const optionsAttr = this.element.dataset.showMoreFilterOptionsValue;
      this.amenityChoices = optionsAttr ? JSON.parse(optionsAttr) : {};
      this.filters = Object.keys(this.amenityChoices);
    } else if (this.idPrefix === 'property-type') {
      this.propertyTypeChoices = {
        "vacation_rental": "Vacation Rental",
        "hotel": "Hotel",
        "rental": "Rental",
        "hostel": "Hostel",
        "resort": "Resort"
      };
      this.filters = Object.keys(this.propertyTypeChoices);
    }

    this.checkedFilters = new Set();
    if (this.idPrefix === 'amenities') {
      const params = new URLSearchParams(window.location.search);
      const amenityCodes = params.getAll('amenity').concat(params.getAll('attributes'));
      amenityCodes.forEach(code => {
        if (this.filters.includes(code)) {
          this.checkedFilters.add(code);
        }
      });
    } else if (this.idPrefix === 'property-type') {
      const params = new URLSearchParams(window.location.search);
      const propertyTypeCodes = params.getAll('property_type');
      propertyTypeCodes.forEach(code => {
        if (this.filters.includes(code)) {
          this.checkedFilters.add(code);
        }
      });
    }
    this.visibleFilters = this.idPrefix === 'property-type' ? 4 : 6;
    this.renderFilters();
  }

  toggleCheckbox(event) {
    const filterName = event.target.dataset.filterName;
    if (event.target.checked) {
      this.checkedFilters.add(filterName);
    } else {
      this.checkedFilters.delete(filterName);
    }
  }

  renderFilters() {
    this.filterContainerTarget.innerHTML = "";

    this.filters.forEach((filter, index) => {
      const uniqueId = `${this.idPrefix}-checkbox-${index}`;
      let isChecked = this.checkedFilters.has(filter);
      let label = filter;
      let value = filter;
      if (this.idPrefix === 'amenities') {
        label = this.amenityChoices[filter];
        value = filter;
      } else if (this.idPrefix === 'property-type') {
        label = this.propertyTypeChoices[filter];
        value = filter;
      }
      if (index < this.visibleFilters) {
        const filterElement = `
          <div class="flex items-center gap-4">
              <input type="checkbox" class="checkbox custom-checkbox" id="${uniqueId}"
              name="${this.idPrefix === 'amenities' ? 'amenity' : 'property_type'}"
              value="${value}"
              data-filter-name="${value}"
              ${isChecked ? "checked" : ""} data-action="change->show-more#toggleCheckbox" />
              <label for="${uniqueId}" class="text text-[#222] font-normal text-[14px] leading-[130%]">${label}</label>
          </div>
        `;
        this.filterContainerTarget.insertAdjacentHTML('beforeend', filterElement);
      }
    });
  }

  toggleFilters() {
    const initialCount = this.idPrefix === 'property-type' ? 4 : 6;

    if (this.visibleFilters === initialCount) {
      this.visibleFilters = this.filters.length;
      this.toggleBtnTarget.textContent = "Show less";
    } else {
      this.visibleFilters = initialCount;
      this.toggleBtnTarget.textContent = "Show more";
    }
    this.renderFilters();
  }
}
